import React, { useEffect, useState } from 'react';
import { Slider, withStyles, Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { getCurrentSubTab } from '../../../redux/actions/adminSideMenuAction';
import { database } from '../../../utils/firebase';

const VolumeSlider = withStyles({
    root: {
      color: '#DAA866',
      height: 0,
      padding: 0,
      paddingTop: 2,
      margin: '0rem 0 0.5rem 0',
     
      width: 135,
     
     
    },
    thumb: {
      height: 10,
      width: 10,
      backgroundColor: '#ffcd8b',
      border: '1px solid #ffcd8b',
      marginTop: -4,
      marginLeft: -0,
      "& .MuiSlider-thumb.Mui-disabled": {
        height: 10,
      width: 10,
      backgroundColor: '#525252 !important',
      border: '1px solid #525252',
      marginTop: -4,
      marginLeft: -0,
      },
      '&:disabled': {
        backgroundColor: '#525252',
        border: '1px solid #525252',
      },
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 3,
      borderRadius: 4,
    },
    rail: {

      height: 3,
      borderRadius: 4,
      backgroundColor: '#525252',
      opacity: 1
    },
  })(Slider);


  const PrettoSlider = withStyles({
    root: {
      color: '#da3849',
      height: 2,
      padding: 0,
      paddingTop: 3,
      width: '98.8%',
     
     
    },
    thumb: {
      height: 10,
      width: 10,
      backgroundColor: '#da3849',
      border: '2px solid currentColor',
      marginTop: -4,
      marginLeft: -0,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 3,
      borderRadius: 4,
    },
    rail: {

      height: 3,
      borderRadius: 4,
      backgroundColor: '#B4B4B4',
      opacity: 1
    },
  })(Slider);


const LangComponent = ({language, url, id, live}) => {
    
    const [volume, setVolume] = useState(0.5)
    const [playState1, setPlayState1] = useState('pause')
    const [speaker1, setSpeaker1] = useState(false)
    const [duration, setDuration] = useState('');
    const [seekTime, setSeekTime] = useState('');
    const [time, setTime] = useState('');
    const dispatch = useDispatch()

    const calculateTime = (secs) => {
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${minutes}:${returnedSeconds}`;
      }

    useEffect(() => {
        dispatch(getCurrentSubTab('s2trans'))
    }, [dispatch])

    useEffect(() => {
        setTime(calculateTime(seekTime))
    }, [seekTime]);
  

    const handlePlayToggle = (playState, id) => {
        
        if (playState === 'playState1' ) {
            const audio = document.getElementById(id)
            if(playState1 === 'play') {
                audio.pause()
                setPlayState1('pause')
            } else {
                audio.play()
                setPlayState1('play')
            }
        }

       
    }

    const handleSpeakerToggle = (playState, id) => {
        
        if (playState === 'speaker1' ) {
            const audio = document.getElementById(id)
            if( speaker1 === false) {
                audio.muted = true
                setSpeaker1(true)
            } else {
                audio.muted = false
                setSpeaker1(false)
            }
        }
       
    }

    const handleMetaData = (id) => {
        const audio = document.getElementById(id)
        const dd = audio.duration
        if(audio.duration === Infinity) {
          setDuration(20)
          console.log('hhhhhh')
        } else {
          setDuration(audio.duration)
        }
        
    }

    const onSeek = (e, newValue) => {
        const audio = document.getElementById('audio')
        setSeekTime(newValue)
        audio.currentTime = newValue
    }

    const handleTimeUpdate = (id) => {
        const audio = document.getElementById(id)
        setSeekTime(Math.floor(audio.currentTime))
        if(audio.duration === Infinity) {
            if( seekTime === (duration - 5)) {
              setDuration(parseInt(seekTime * 2))
            }
        } 
    }

    const handleVolumeChange = (e, newValue, id) => {
        const audio = document.getElementById(id)
        setVolume(newValue)
        audio.volume = newValue
    }

    const handleGoLive = () => {
      const langRef = database.ref('Languages').child(id)
      langRef.update({
          live: true
      })
  }

  const handleLive = () => {
      const langRef = database.ref('Languages').child(id)
      langRef.update({
          live: false
      })
  }

    return (
        <div className="lang-trans">
          <h4>{language}</h4>
          <div className="trans-field">
              <div className="lang-trans-container">
                  <div className='container'>
                      <div className='speech-to-text'>
                          <p>{url}</p>
                      </div>
                  </div>
                  <audio src={url} loop  preload='metadata' id={`audio-${language}`} onLoadedMetadata={() => handleMetaData(`audio-${language}`)} onTimeUpdate={() => handleTimeUpdate(`audio-${language}`)}/>

                  <PrettoSlider 
                  min={0}
                  max={duration? Math.floor(duration) : 100}
                  defaultValue={0}
                  value={seekTime}
                  // onChange={onSeek}
                  // onMouseDown={onSeekMouseDown}
                  // onChangeCommitted={onSeekMouseUp}
                  // ValueLabelComponent={(props) => (
                  // <ValueLabelComponent {...props} value={seekTime}/>)}
                  />

                  <div className="track-details">
                      <p className="time">{time}</p>
                      {live? <p className="status live-con">Live</p> : <p className="status live-con hide">Live</p>}   
                  </div>

                  <div className="track-controls">
                      {playState1 === 'play'? <i class="fas fa-pause-circle play-pause " onClick={() => handlePlayToggle('playState1', `audio-${language}`)}></i> : <i class="fas fa-play-circle play-pause " onClick={() => handlePlayToggle('playState1', `audio-${language}`)}></i>}
                      {!speaker1? <i class="fas fa-volume-up volume " onClick={() => handleSpeakerToggle('speaker1', `audio-${language}`)}></i> : <i class="fas fa-volume-mute volume" onClick={() => handleSpeakerToggle('speaker1', `audio-${language}`)} ></i>}
                      <VolumeSlider 
                          className="range"
                          value={volume} 
                          onChange={(e, newValue) => handleVolumeChange(e, newValue, `audio-${language}`)} 
                          aria-labelledby="continuous-slider" 
                          step={0.010}  
                          min={0}
                          max={1}
                          disabled={speaker1}
                          />                                
                  </div>
              </div>  
              {live? <button onClick={handleLive}>LIVE</button> : <button className='go-live' onClick={handleGoLive}>Go LIVE</button>   }                
                      
          </div>
      </div>
    )
}

export default LangComponent